// Navigation data for SiteHeader and SiteFooter.
// Name strings are PT source keys for translateWord, unless literal: true.

export const megas = [
  {
    "id": "products",
    "label": "Produtos",
    "groupsClass": "mm-groups-3",
    "groups": [
      {
        "id": "mm-products-g1",
        "label": "COM IA",
        "items": [
          {
            "slug": "ai-website",
            "name": "AI Website Builder",
            "literal": true,
            "desc": "Crie sites completos a partir de um simples prompt.",
            "icon": "<path d=\"m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72\"/><path d=\"m14 7 3 3\"/><path d=\"M5 6v4\"/><path d=\"M19 14v4\"/><path d=\"M10 2v2\"/><path d=\"M7 8H3\"/><path d=\"M21 16h-4\"/><path d=\"M11 3H9\"/>"
          },
          {
            "slug": "agent-chat",
            "name": "AI Market Agent",
            "literal": true,
            "desc": "Planeje, pesquise e faça seu negócio crescer com IA.",
            "icon": "<path d=\"M12 8V4H8\"/><rect width=\"16\" height=\"12\" x=\"4\" y=\"8\" rx=\"2\"/><path d=\"M2 14h2\"/><path d=\"M20 14h2\"/><path d=\"M15 13v2\"/><path d=\"M9 13v2\"/>"
          },
          {
            "slug": "ai-email",
            "name": "AI Email Builder",
            "literal": true,
            "desc": "Crie campanhas e sequências de e-mail com IA.",
            "icon": "<path d=\"M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9\"/><path d=\"m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7\"/><path d=\"M16 19h6\"/><path d=\"M19 16v6\"/>"
          },
          {
            "slug": "ai-website-hosting",
            "name": "AI Website Hosting",
            "literal": true,
            "desc": "Publique seu site criado com IA e conecte suas ferramentas de negócio.",
            "icon": "<path d=\"M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z\"/>"
          },
          {
            "slug": "magiclab",
            "name": "Magic Lab",
            "literal": true,
            "desc": "Gere e transforme imagens com IA.",
            "icon": "<path d=\"M11.02 2.6a.5.5 0 0 1 .96 0l1.58 6.14a2 2 0 0 0 1.44 1.44l6.14 1.58a.5.5 0 0 1 0 .96l-6.14 1.58a2 2 0 0 0-1.44 1.44l-1.58 6.14a.5.5 0 0 1-.96 0l-1.58-6.14a2 2 0 0 0-1.44-1.44L2.34 12.7a.5.5 0 0 1 0-.96l6.14-1.58a2 2 0 0 0 1.44-1.44z\"/><path d=\"M20 3v4\"/><path d=\"M22 5h-4\"/><path d=\"M4 17v2\"/><path d=\"M5 18H3\"/>"
          }
        ]
      },
      {
        "id": "mm-products-g2",
        "label": "Criação e Suporte",
        "items": [
          {
            "slug": "builderall-builder",
            "linkKey": "bigmenu.ourTools.websites",
            "name": "Website Builder",
            "literal": true,
            "desc": "Crie sites, landing pages e funis.",
            "icon": "<rect x=\"2\" y=\"4\" width=\"20\" height=\"16\" rx=\"2\"/><path d=\"M2 9h20\"/><path d=\"M6 6.5h.01\"/><path d=\"M9.5 6.5h.01\"/>"
          },
          {
            "slug": "domain-registration",
            "name": "Registro de domínios",
            "desc": "Encontre e conecte o domínio perfeito para o seu negócio.",
            "icon": "<circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20\"/><path d=\"M2 12h20\"/>"
          },
          {
            "slug": "wordpress",
            "name": "WordPress",
            "literal": true,
            "desc": "Crie e gerencie seu site WordPress.",
            "icon": "<rect width=\"7\" height=\"9\" x=\"3\" y=\"3\" rx=\"1\"/><rect width=\"7\" height=\"5\" x=\"14\" y=\"3\" rx=\"1\"/><rect width=\"7\" height=\"9\" x=\"14\" y=\"12\" rx=\"1\"/><rect width=\"7\" height=\"5\" x=\"3\" y=\"16\" rx=\"1\"/>"
          },
          {
            "slug": "elearning-builder",
            "linkKey": "bigmenu.ourTools.courses",
            "name": "E-learning",
            "literal": true,
            "desc": "Crie, venda e gerencie cursos on-line.",
            "icon": "<path d=\"M10 7.75a.75.75 0 0 1 1.14-.64l3.67 2.25a.75.75 0 0 1 0 1.28l-3.67 2.25a.75.75 0 0 1-1.14-.64z\"/><path d=\"M12 17v4\"/><path d=\"M8 21h8\"/><rect x=\"2\" y=\"3\" width=\"20\" height=\"14\" rx=\"2\"/>"
          },
          {
            "slug": "funnel-builder",
            "linkKey": "bigmenu.ourTools.funnels",
            "name": "Funnel Builder",
            "literal": true,
            "desc": "Crie jornadas do cliente feitas para converter.",
            "icon": "<circle cx=\"6\" cy=\"19\" r=\"3\"/><path d=\"M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15\"/><circle cx=\"18\" cy=\"5\" r=\"3\"/>"
          }
        ]
      },
      {
        "id": "mm-products-g3",
        "label": "ENGAJE E VENDA",
        "items": [
          {
            "slug": "mailingboss",
            "linkKey": "bigmenu.ourTools.mailingboss",
            "name": "Email Marketing",
            "desc": "Crie disparos, campanhas e automações.",
            "peach": true,
            "icon": "<rect width=\"20\" height=\"16\" x=\"2\" y=\"4\" rx=\"2\"/><path d=\"m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7\"/>"
          },
          {
            "slug": "marketing-automation",
            "name": "Automações",
            "desc": "Conecte ações e automatize seu marketing.",
            "peach": true,
            "icon": "<rect width=\"8\" height=\"8\" x=\"3\" y=\"3\" rx=\"2\"/><path d=\"M7 11v4a2 2 0 0 0 2 2h4\"/><rect width=\"8\" height=\"8\" x=\"13\" y=\"13\" rx=\"2\"/>"
          },
          {
            "slug": "whatsapp-central",
            "name": "WhatsApp Central",
            "literal": true,
            "desc": "Capte leads e se comunique pelo WhatsApp.",
            "peach": true,
            "icon": "<path d=\"M7.9 20A9 9 0 1 0 4 16.1L2 22Z\"/>"
          },
          {
            "slug": "booking-builder",
            "linkKey": "bigmenu.ourTools.booking",
            "name": "Reservas & Agendamentos",
            "desc": "Deixe seus clientes agendarem reuniões e horários.",
            "icon": "<rect width=\"18\" height=\"18\" x=\"3\" y=\"4\" rx=\"2\"/><path d=\"M3 10h18\"/><path d=\"M8 2v4\"/><path d=\"M16 2v4\"/><path d=\"M9 15h2\"/>"
          },
          {
            "slug": "super-checkout",
            "name": "Super Checkout",
            "literal": true,
            "desc": "Venda produtos, serviços e assinaturas.",
            "icon": "<circle cx=\"8\" cy=\"21\" r=\"1\"/><circle cx=\"19\" cy=\"21\" r=\"1\"/><path d=\"M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12\"/>"
          },
          {
            "slug": "webinar-builder",
            "linkKey": "bigmenu.ourTools.webinars",
            "name": "Webinar Builder",
            "literal": true,
            "desc": "Realize webinars ao vivo, gravados e evergreen.",
            "icon": "<path d=\"m16 13 5.22 3.48a.5.5 0 0 0 .78-.42V7.94a.5.5 0 0 0-.75-.43L16 10.5\"/><rect x=\"2\" y=\"6\" width=\"14\" height=\"12\" rx=\"2\"/>"
          },
          {
            "slug": "professional-email",
            "name": "Email Profissional",
            "desc": "Crie endereços de e-mail personalizados com o seu domínio.",
            "icon": "<circle cx=\"12\" cy=\"12\" r=\"4\"/><path d=\"M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8\"/>"
          }
        ]
      }
    ],
    "foot": {
      "slug": "our-tools",
      "linkKey": "ourTools",
      "name": "Conheça todas as mais de 25 ferramentas"
    },
    "promo": {
      "art": "website",
      "pill": "DESTAQUE",
      "title": "Crie um site com IA",
      "desc": "Transforme sua ideia em um site completo em minutos.",
      "cta": "Conheça o AI Website",
      "slug": "ai-website"
    }
  },
  {
    "id": "solutions",
    "label": "Soluções",
    "groupsClass": "mm-groups-2",
    "groups": [
      {
        "id": "mm-solutions-g1",
        "label": "POR TIPO DE NEGÓCIO",
        "items": [
          {
            "slug": "solutions-agency",
            "linkKey": "bigmenu.solutions.agencies",
            "name": "Agências",
            "desc": "Gerencie clientes e escale sua agência.",
            "icon": "<path d=\"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2\"/><circle cx=\"9\" cy=\"7\" r=\"4\"/><path d=\"M22 21v-2a4 4 0 0 0-3-3.87\"/><path d=\"M16 3.13a4 4 0 0 1 0 7.75\"/>"
          },
          {
            "slug": "solutions-small-business",
            "name": "Pequenas empresas",
            "desc": "Tudo o que você precisa para crescer on-line.",
            "icon": "<path d=\"m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7\"/><path d=\"M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8\"/><path d=\"M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4\"/><path d=\"M2 7h20\"/>"
          },
          {
            "slug": "solutions-course-creator",
            "linkKey": "bigmenu.solutions.courseCreator",
            "name": "Criadores de Cursos",
            "desc": "Crie, venda e entregue cursos on-line.",
            "icon": "<path d=\"M2 3h20\"/><path d=\"M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3\"/><path d=\"m7 21 5-5 5 5\"/>"
          },
          {
            "slug": "solutions-health",
            "linkKey": "bigmenu.solutions.healthWellness",
            "name": "Saúde e bem estar",
            "desc": "Elevando o nível da sua marca de saúde e bem-estar.",
            "icon": "<path d=\"M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z\"/><path d=\"M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27\"/>"
          },
          {
            "slug": "solutions-startups",
            "linkKey": "bigmenu.solutions.startup",
            "name": "Startups",
            "literal": true,
            "desc": "Da ideação à escala. Nós ajudamos você.",
            "icon": "<path d=\"M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91 0z\"/><path d=\"m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z\"/><path d=\"M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0\"/><path d=\"M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5\"/>"
          },
          {
            "slug": "membership-organizations",
            "name": "Organizações de membros",
            "desc": "Benefícios exclusivos para seus membros.",
            "icon": "<path d=\"M16 10h2\"/><path d=\"M16 14h2\"/><path d=\"M6.17 15a3 3 0 0 1 5.66 0\"/><circle cx=\"9\" cy=\"11\" r=\"2\"/><rect x=\"2\" y=\"5\" width=\"20\" height=\"14\" rx=\"2\"/>"
          }
        ]
      },
      {
        "id": "mm-solutions-g2",
        "label": "POR OBJETIVO",
        "items": [
          {
            "slug": "build-a-website",
            "name": "Criar um site",
            "desc": "Coloque sua ideia on-line.",
            "icon": "<rect width=\"20\" height=\"14\" x=\"2\" y=\"3\" rx=\"2\"/><path d=\"M8 21h8\"/><path d=\"M12 17v4\"/>"
          },
          {
            "slug": "generate-leads",
            "name": "Gerar leads",
            "desc": "Transforme visitantes em clientes.",
            "peach": true,
            "icon": "<path d=\"M22 3H2l8 9.46V19l4 2v-8.54z\"/>"
          },
          {
            "slug": "sell-online",
            "name": "Vender on-line",
            "desc": "Crie ofertas e aumente suas vendas.",
            "icon": "<path d=\"M3 3v16a2 2 0 0 0 2 2h16\"/><path d=\"M18 17V9\"/><path d=\"M13 17V5\"/><path d=\"M8 17v-3\"/>"
          },
          {
            "slug": "marketing-automation",
            "name": "Automatizar o marketing",
            "desc": "Economize tempo e cresça mais rápido.",
            "peach": true,
            "icon": "<path d=\"M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z\"/>"
          },
          {
            "slug": "solutions-course-creator",
            "linkKey": "bigmenu.solutions.courseCreator",
            "name": "Criar cursos on-line",
            "desc": "Compartilhe seu conhecimento mais rápido.",
            "icon": "<path d=\"M12 7v14\"/><path d=\"M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z\"/>"
          }
        ]
      }
    ],
    "foot": {
      "slug": "solutions",
      "name": "Conheça todas as soluções"
    },
    "promo": {
      "art": "agencies",
      "peach": true,
      "pill": "Para agências",
      "title": "Gerencie clientes. Cresça mais rápido.",
      "desc": "Sites, funis, automação e muito mais — tudo em um só lugar.",
      "cta": "Conheça a solução para agências",
      "slug": "solutions-agency",
      "linkKey": "bigmenu.solutions.agencies"
    }
  },
  {
    "id": "resources",
    "label": "Recursos",
    "groupsClass": "mm-groups-3",
    "groups": [
      {
        "id": "mm-resources-g1",
        "label": "APRENDA",
        "items": [
          {
            "linkKey": "blog",
            "name": "Blog",
            "literal": true,
            "desc": "Dicas, insights e estratégias.",
            "icon": "<path d=\"M15 18h-5\"/><path d=\"M18 14h-8\"/><path d=\"M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2\"/>"
          },
          {
            "slug": "learn",
            "linkKey": "bigmenu.solutions.builderallLearn",
            "name": "Builderall Academy",
            "literal": true,
            "desc": "Aprenda e cresça com tutoriais.",
            "icon": "<path d=\"M21.42 10.92a1 1 0 0 0-.02-1.84L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.84l8.57 3.9a2 2 0 0 0 1.66 0z\"/><path d=\"M22 10v6\"/><path d=\"M6 12.5V16a6 3 0 0 0 12 0v-3.5\"/>"
          },
          {
            "slug": "website-mastery-course",
            "name": "Curso de domínio de sites",
            "desc": "Da ideia ao lançamento.",
            "icon": "<path d=\"m15.48 12.89 1.51 8.53a.5.5 0 0 1-.81.47l-3.58-2.69a1 1 0 0 0-1.2 0l-3.58 2.69a.5.5 0 0 1-.81-.47l1.51-8.53\"/><circle cx=\"12\" cy=\"8\" r=\"6\"/>"
          },
          {
            "slug": "email-marketing-mastery",
            "name": "Domínio de e-mail marketing",
            "desc": "Domine o e-mail marketing.",
            "peach": true,
            "icon": "<path d=\"M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8\"/><path d=\"m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7\"/><path d=\"m16 19 2 2 4-4\"/>"
          },
          {
            "slug": "tutorials",
            "name": "Tutoriais",
            "desc": "Guias passo a passo.",
            "icon": "<circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M10 8.64a.5.5 0 0 1 .77-.42l4.6 2.94a.5.5 0 0 1 0 .84l-4.6 2.94a.5.5 0 0 1-.77-.42z\"/>"
          },
          {
            "slug": "guides",
            "name": "Guias",
            "desc": "Conteúdos aprofundados.",
            "icon": "<path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/>"
          }
        ]
      },
      {
        "id": "mm-resources-g2",
        "label": "DESCUBRA",
        "items": [
          {
            "slug": "templates",
            "name": "Modelos de sites",
            "desc": "Modelos com design profissional.",
            "icon": "<rect width=\"18\" height=\"7\" x=\"3\" y=\"3\" rx=\"1\"/><rect width=\"9\" height=\"7\" x=\"3\" y=\"14\" rx=\"1\"/><rect width=\"5\" height=\"7\" x=\"16\" y=\"14\" rx=\"1\"/>"
          },
          {
            "slug": "integrations",
            "linkKey": "bigmenu.solutions.integration",
            "name": "Integrações",
            "desc": "Conecte suas ferramentas favoritas.",
            "icon": "<path d=\"M14 3.5a2.5 2.5 0 0 1 4.44 1.56V7H20a1 1 0 0 1 1 1v3.06A2.5 2.5 0 1 0 21 16v4a1 1 0 0 1-1 1h-4.44a2.5 2.5 0 1 0-5 0H6a1 1 0 0 1-1-1v-4a2.5 2.5 0 1 1 0-4.94V8a1 1 0 0 1 1-1h1.56A2.5 2.5 0 0 1 12 3.06\"/>"
          },
          {
            "slug": "partners",
            "linkKey": "partners",
            "name": "Parceiros",
            "desc": "Cresça junto com a Builderall.",
            "icon": "<path d=\"m11 17 2 2a1 1 0 1 0 3-3\"/><path d=\"m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4\"/><path d=\"m21 3 1 11h-2\"/><path d=\"M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3\"/><path d=\"M3 4h8\"/>"
          },
          {
            "slug": "affiliate-program",
            "linkKey": "affiliate",
            "name": "Programa de afiliados",
            "desc": "Ganhe indicando a Builderall.",
            "peach": true,
            "icon": "<circle cx=\"18\" cy=\"5\" r=\"3\"/><circle cx=\"6\" cy=\"12\" r=\"3\"/><circle cx=\"18\" cy=\"19\" r=\"3\"/><path d=\"m8.59 13.51 6.83 3.98\"/><path d=\"m15.41 6.51-6.82 3.98\"/>"
          }
        ]
      },
      {
        "id": "mm-resources-g3",
        "label": "Atendimento",
        "items": [
          {
            "slug": "help-center",
            "name": "Central de ajuda",
            "desc": "Encontre respostas rapidamente.",
            "icon": "<circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3\"/><path d=\"M12 17h.01\"/>"
          },
          {
            "slug": "support",
            "linkKey": "getSupport",
            "name": "Falar com o suporte",
            "desc": "Entre em contato com nossa equipe.",
            "icon": "<path d=\"M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3\"/>"
          },
          {
            "slug": "spam-report",
            "name": "Denunciar spam",
            "desc": "Ajude-nos a manter a Builderall segura.",
            "icon": "<path d=\"M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z\"/><path d=\"M12 8v4\"/><path d=\"M12 16h.01\"/>"
          }
        ]
      }
    ],
    "foot": {
      "slug": "resources",
      "name": "Ver todos os recursos"
    },
    "promo": {
      "art": "academy",
      "pill": "BUILDERALL ACADEMY",
      "pillLiteral": true,
      "title": "Aprenda. Aplique. Cresça.",
      "desc": "Desenvolva as habilidades de que você precisa para fazer seu negócio digital crescer.",
      "cta": "Comece a aprender",
      "slug": "learn",
      "linkKey": "bigmenu.solutions.builderallLearn"
    }
  }
];

export const footerColumns = [
  {
    "id": "f-col-1",
    "label": "Produtos",
    "links": [
      {
        "slug": "ai-website",
        "name": "AI Website Builder",
        "literal": true
      },
      {
        "slug": "agent-chat",
        "name": "AI Market Agent",
        "literal": true
      },
      {
        "slug": "ai-email",
        "name": "AI Email Builder",
        "literal": true
      },
      {
        "slug": "magiclab",
        "name": "Magic Lab",
        "literal": true
      },
      {
        "slug": "builderall-builder",
        "linkKey": "bigmenu.ourTools.websites",
        "name": "Website Builder",
        "literal": true
      },
      {
        "slug": "templates",
        "name": "Modelos de sites"
      },
      {
        "slug": "ai-website-hosting",
        "name": "AI Website Hosting",
        "literal": true
      },
      {
        "slug": "domain-registration",
        "name": "Registro de domínios"
      },
      {
        "slug": "mailingboss",
        "linkKey": "bigmenu.ourTools.mailingboss",
        "name": "Email Marketing"
      },
      {
        "slug": "marketing-automation",
        "name": "Automação de marketing"
      },
      {
        "slug": "whatsapp-central",
        "name": "WhatsApp Central",
        "literal": true
      },
      {
        "slug": "super-checkout",
        "name": "Super Checkout",
        "literal": true
      },
      {
        "slug": "booking-builder",
        "linkKey": "bigmenu.ourTools.booking",
        "name": "Reservas e agendamentos"
      },
      {
        "slug": "elearning-builder",
        "linkKey": "bigmenu.ourTools.courses",
        "name": "E-learning",
        "literal": true
      },
      {
        "slug": "webinar-builder",
        "linkKey": "bigmenu.ourTools.webinars",
        "name": "Webinar Builder",
        "literal": true
      },
      {
        "slug": "professional-email",
        "name": "Email Profissional"
      },
      {
        "slug": "wordpress",
        "name": "WordPress",
        "literal": true
      }
    ]
  },
  {
    "id": "f-col-2",
    "label": "Soluções",
    "links": [
      {
        "slug": "solutions-agency",
        "linkKey": "bigmenu.solutions.agencies",
        "name": "Para agências"
      },
      {
        "slug": "solutions-small-business",
        "name": "Para pequenas empresas"
      },
      {
        "slug": "solutions-course-creator",
        "linkKey": "bigmenu.solutions.courseCreator",
        "name": "Para criadores de cursos"
      },
      {
        "slug": "solutions-coaches",
        "name": "Para coaches"
      },
      {
        "slug": "builderall-ecommerce",
        "linkKey": "bigmenu.ourTools.ecommerce",
        "name": "Para e-commerce"
      },
      {
        "slug": "solutions-startups",
        "linkKey": "bigmenu.solutions.startup",
        "name": "Para startups"
      },
      {
        "slug": "solutions-local-business",
        "name": "Para negócios locais"
      },
      {
        "slug": "membership-organizations",
        "name": "Para assinaturas"
      }
    ]
  },
  {
    "id": "f-col-3",
    "label": "Conteúdos",
    "links": [
      {
        "linkKey": "blog",
        "name": "Blog",
        "literal": true
      },
      {
        "slug": "templates",
        "name": "Modelos de sites"
      },
      {
        "slug": "integrations",
        "linkKey": "bigmenu.solutions.integration",
        "name": "Integrações"
      },
      {
        "slug": "tutorials",
        "name": "Tutoriais"
      },
      {
        "slug": "guides",
        "name": "Guias"
      },
      {
        "slug": "learn",
        "linkKey": "bigmenu.solutions.builderallLearn",
        "name": "Builderall Academy",
        "literal": true
      },
      {
        "slug": "website-mastery-course",
        "name": "Curso de domínio de sites"
      },
      {
        "slug": "email-marketing-mastery",
        "name": "Curso de domínio de e-mail marketing"
      },
      {
        "slug": "customer-stories",
        "name": "Histórias de clientes"
      },
      {
        "slug": "product-updates",
        "name": "Novidades do produto"
      }
    ]
  },
  {
    "id": "f-col-4",
    "label": "Empresa",
    "links": [
      {
        "slug": "about-us",
        "linkKey": "about",
        "name": "Sobre a Builderall"
      },
      {
        "self": true,
        "name": "Preços"
      },
      {
        "slug": "partners",
        "linkKey": "partners",
        "name": "Parceiros"
      },
      {
        "slug": "affiliate-program",
        "linkKey": "affiliate",
        "name": "Programa de afiliados"
      },
      {
        "slug": "careers",
        "name": "Carreiras"
      },
      {
        "linkKey": "login",
        "name": "Login"
      }
    ]
  },
  {
    "id": "f-col-5",
    "label": "Atendimento",
    "links": [
      {
        "slug": "help-center",
        "name": "Central de ajuda"
      },
      {
        "slug": "support",
        "linkKey": "getSupport",
        "name": "Falar com o suporte"
      },
      {
        "url": "https://status.builderall.com/",
        "bare": true,
        "name": "Status do sistema"
      },
      {
        "slug": "community",
        "name": "Comunidade"
      },
      {
        "slug": "spam-report",
        "name": "Denunciar spam"
      }
    ]
  },
  {
    "id": "f-col-6",
    "label": "Jurídico",
    "links": [
      {
        "slug": "terms-of-use",
        "linkKey": "termsOfUse",
        "name": "Termos de Uso"
      },
      {
        "linkKey": "privacyPolice",
        "name": "Política de privacidade"
      },
      {
        "linkKey": "cookiePolicy",
        "name": "Política de cookies"
      },
      {
        "slug": "domain-registration-terms",
        "linkKey": "domainRegistrationTerms",
        "name": "Termos de registro de domínios"
      },
      {
        "slug": "security",
        "linkKey": "security",
        "name": "Segurança"
      },
      {
        "slug": "accessibility",
        "linkKey": "accessibility",
        "name": "Acessibilidade"
      }
    ]
  }
];

export const socials = [
  {
    "linkKey": "facebook",
    "url": "https://www.facebook.com/groups/builderall/",
    "name": "Facebook",
    "literal": true,
    "bare": true
  },
  {
    "linkKey": "youtube",
    "url": "https://www.youtube.com/@BuilderallUSA",
    "name": "YouTube",
    "literal": true,
    "bare": true
  },
  {
    "linkKey": "instagram",
    "url": "https://www.instagram.com/builderallofficial_/",
    "name": "Instagram",
    "literal": true,
    "bare": true
  }
];

var BARE_HOST = /^(https?:)?\/\/(status|thebuild)\.builderall\.com/i;
var SOCIAL_HOST = /facebook\.com|instagram\.com|youtube\.com|youtu\.be/i;

function lookup(links, key) {
  if (!links || !key) return '';
  var parts = key.split('.');
  var cur = links;
  for (var i = 0; i < parts.length; i++) {
    if (!cur || typeof cur !== 'object') return '';
    cur = cur[parts[i]];
  }
  return typeof cur === 'string' ? cur : '';
}

function destination(item, links) {
  if (item.url) return item.url;
  if (item.linkKey) {
    var fromKey = lookup(links, item.linkKey);
    if (fromKey) return fromKey;
  }
  if (item.slug) return 'https://builderall.com/' + item.slug;
  return '';
}

function builderallHost(url) {
  return /builderall\.com|builderallstatic\.com|builderall\.io/i.test(url);
}

export function resolveHref(item, links, params, selfHref) {
  if (!item) return '';
  if (item.self) {
    var base = selfHref || '';
    return item.bare ? base : joinParams(base, params);
  }
  var url = destination(item, links);
  if (!url || item.bare) return url;
  if (BARE_HOST.test(url) || SOCIAL_HOST.test(url)) return url;
  if (!builderallHost(url)) return url;
  return joinParams(url, params);
}

function joinParams(url, params) {
  if (!url || !params) return url || '';
  var q = params.charAt(0) === '?' ? params.slice(1) : params;
  if (!q) return url;
  if (url.indexOf('#') !== -1) return url;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + q;
}
